import React from 'react';
import { Box, Text, Button } from '@spothero/ui';
import { useSelector } from 'react-redux';
import UrlUtils from '@spothero/utils/url';
import { onViewClickWithSegment } from '../utils';
export const NotGoingToEvent = () => {
    const title = useSelector((state) => state.destination.data.title);
    const destinationId = useSelector((state) => state.destination.data.id);
    const queryParams = UrlUtils.parseParams(window.location.search);
    const transientClick = () => onViewClickWithSegment({ title, destinationId, queryParams });
    return (<Box data-testid="NotGoingToEvent" flex={{ desktop: '1 1 auto' }} display={{ base: 'inline-block', tablet: 'flex' }} pt={{ base: 2, tablet: 4 }} pb={{ base: 3, tablet: 2 }} justifyContent="center">
            <Text fontSize="sm" fontWeight="normal" mr={{ base: 0, tablet: 2 }}>
                Not going to an event?
            </Text>
            <Button variant="tertiary" onClick={transientClick} fontSize="sm">
                Search for hourly or daily parking instead.
            </Button>
        </Box>);
};
